// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ValidationErrorBanner.css */

.validation-error-banner {
  background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%);
  border: 2px solid #ef4444;
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 24px;
  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.15);
  animation: slideDown 0.3s ease-out;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.banner-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.banner-title {
  display: flex;
  align-items: center;
  gap: 12px;
}

.error-icon {
  font-size: 28px;
  animation: pulse 2s ease-in-out infinite;
}

@keyframes pulse {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
}

.banner-title h3 {
  margin: 0;
  color: #991b1b;
  font-size: 18px;
  font-weight: 700;
}

.close-button {
  background: transparent;
  border: none;
  color: #991b1b;
  font-size: 24px;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 6px;
  transition: all 0.2s ease;
  line-height: 1;
}

.close-button:hover {
  background-color: #fecaca;
  transform: scale(1.1);
}

.banner-content {
  margin-top: 12px;
}

.banner-subtitle {
  color: #7f1d1d;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 12px;
}

.error-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.error-list li {
  background: white;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #fecaca;
  transition: all 0.2s ease;
}

.error-list li:hover {
  border-color: #ef4444;
  box-shadow: 0 2px 8px rgba(239, 68, 68, 0.15);
  transform: translateX(4px);
}

.field-link {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  background: transparent;
  border: none;
  cursor: pointer;
  text-align: left;
  transition: background-color 0.2s ease;
}

.field-link:hover {
  background-color: #fef2f2;
}

.field-number {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  background: #ef4444;
  color: white;
  border-radius: 50%;
  font-size: 12px;
  font-weight: 700;
  flex-shrink: 0;
}

.field-name {
  flex: 1 1;
  color: #991b1b;
  font-size: 14px;
  font-weight: 600;
}

.go-to-field {
  color: #ef4444;
  font-size: 20px;
  font-weight: 700;
  transition: transform 0.2s ease;
}

.field-link:hover .go-to-field {
  transform: translateX(4px);
}

/* Responsivo */
@media (max-width: 768px) {
  .validation-error-banner {
    padding: 16px;
    margin-bottom: 16px;
  }

  .banner-title h3 {
    font-size: 16px;
  }

  .error-icon {
    font-size: 24px;
  }

  .field-link {
    padding: 10px 12px;
  }

  .field-name {
    font-size: 13px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/Cadastro/Produtos/FormProduto/ModalPizza/Body/ValidationErrorBanner.css"],"names":[],"mappings":"AAAA,8BAA8B;;AAE9B;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,8CAA8C;EAC9C,kCAAkC;AACpC;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;EAC7C,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,eAAe;AACf;EACE;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* ValidationErrorBanner.css */\n\n.validation-error-banner {\n  background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%);\n  border: 2px solid #ef4444;\n  border-radius: 12px;\n  padding: 20px;\n  margin-bottom: 24px;\n  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.15);\n  animation: slideDown 0.3s ease-out;\n}\n\n@keyframes slideDown {\n  from {\n    opacity: 0;\n    transform: translateY(-20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.banner-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 16px;\n}\n\n.banner-title {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.error-icon {\n  font-size: 28px;\n  animation: pulse 2s ease-in-out infinite;\n}\n\n@keyframes pulse {\n  0%, 100% {\n    transform: scale(1);\n  }\n  50% {\n    transform: scale(1.1);\n  }\n}\n\n.banner-title h3 {\n  margin: 0;\n  color: #991b1b;\n  font-size: 18px;\n  font-weight: 700;\n}\n\n.close-button {\n  background: transparent;\n  border: none;\n  color: #991b1b;\n  font-size: 24px;\n  cursor: pointer;\n  padding: 4px 8px;\n  border-radius: 6px;\n  transition: all 0.2s ease;\n  line-height: 1;\n}\n\n.close-button:hover {\n  background-color: #fecaca;\n  transform: scale(1.1);\n}\n\n.banner-content {\n  margin-top: 12px;\n}\n\n.banner-subtitle {\n  color: #7f1d1d;\n  font-size: 14px;\n  font-weight: 600;\n  margin-bottom: 12px;\n}\n\n.error-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.error-list li {\n  background: white;\n  border-radius: 8px;\n  overflow: hidden;\n  border: 1px solid #fecaca;\n  transition: all 0.2s ease;\n}\n\n.error-list li:hover {\n  border-color: #ef4444;\n  box-shadow: 0 2px 8px rgba(239, 68, 68, 0.15);\n  transform: translateX(4px);\n}\n\n.field-link {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 16px;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  text-align: left;\n  transition: background-color 0.2s ease;\n}\n\n.field-link:hover {\n  background-color: #fef2f2;\n}\n\n.field-number {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  background: #ef4444;\n  color: white;\n  border-radius: 50%;\n  font-size: 12px;\n  font-weight: 700;\n  flex-shrink: 0;\n}\n\n.field-name {\n  flex: 1;\n  color: #991b1b;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.go-to-field {\n  color: #ef4444;\n  font-size: 20px;\n  font-weight: 700;\n  transition: transform 0.2s ease;\n}\n\n.field-link:hover .go-to-field {\n  transform: translateX(4px);\n}\n\n/* Responsivo */\n@media (max-width: 768px) {\n  .validation-error-banner {\n    padding: 16px;\n    margin-bottom: 16px;\n  }\n\n  .banner-title h3 {\n    font-size: 16px;\n  }\n\n  .error-icon {\n    font-size: 24px;\n  }\n\n  .field-link {\n    padding: 10px 12px;\n  }\n\n  .field-name {\n    font-size: 13px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
